export default __webpack_public_path__ + "static/media/cam.d1a3ff20.png";